export const blue = {
  active: 'hsla(216, 68%, 50%, 1)',
  50: 'hsla(205, 87%, 94%, 1)',
  100: 'hsla(207, 89%, 86%, 1)',
  200: 'hsla(207, 90%, 77%, 1)',
  300: 'hsla(211, 100%, 50%, 1)',
  500: 'hsla(211, 100%, 45%, 1)',
  600: 'hsla(208, 79%, 51%, 1)',
  700: 'hsla(211, 100%, 40%, 1)',
};

export type BluePalette = typeof blue;

export const blueOpacities = {
  '4p': 'hsla(211, 100%, 45%, 0.04)',
  '8p': 'hsla(211, 100%, 45%, 0.08)',
  '12p': 'hsla(211, 100%, 45%, 0.12)',
  '30p': 'hsla(211, 100%, 45%, 0.3)',
  '50p': 'hsla(211, 100%, 45%, 0.5)',
};
